import { render, staticRenderFns } from "./FolderListItem.vue?vue&type=template&id=2403e034"
import script from "./FolderListItem.vue?vue&type=script&lang=js"
export * from "./FolderListItem.vue?vue&type=script&lang=js"
import style0 from "./FolderListItem.vue?vue&type=style&index=0&id=2403e034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports